import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { Table, Button, Form } from "react-bootstrap";
import AdmBook from "../AdminBookBarcode/AdmBook";
import { ApiUrl } from "../../../ApiUrl";
import SelectStudentModal from "../AdminAttendanceEntry/SelectStudentModal";
import SelectStaffModal from "./SelectStaffModal ";
import SelectBookSearch from "./SelectBookSearch";

const AdmAttendanceEntry = () => {
  const [showModal, setShowModal] = useState(false);
  const [isModalVisible, setModalVisible] = useState(false);
  const navigate = useNavigate();
  const [isStudentModalVisible, setStudentModalVisible] = useState(false);

  // Issue Book
  // const handleIssueBook = async () => {
  //   const academicYearId = localStorage.getItem("academicSessionId");
  //   const createdBy = sessionStorage.getItem("userId");
  //   const issueDate = document.getElementById("issue-date")?.value || ""; // Get issue date from input
  //   const studentId = localStorage.getItem("studentId");
  //   const issuesBookDetails = rows
  //     .filter((row) => row.bookCode) // Only include rows with books selected
  //     .map((row) => row.id);

  //   if (
  //     !academicYearId ||
  //     !createdBy ||
  //     !issueDate ||
  //     !studentId ||
  //     issuesBookDetails.length === 0
  //   ) {
  //     alert("Please fill all required fields before issuing books.");
  //     return;
  //   }

  //   const requestBody = {
  //     academic_year_id: Number(academicYearId),
  //     staffId: null,
  //     studentId: Number(studentId),
  //     issueDate: issueDate,
  //     issuesBookDetails: issuesBookDetails,
  //     created_by: Number(createdBy),
  //   };

  //   try {
  //     const response = await fetch(
  //       `${ApiUrl.apiurl}ISSUEBOOK/BOOKISSUE_CREATE/`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(requestBody),
  //       }
  //     );

  //     const data = await response.json();
  //     if (data.message === "success") {
  //       alert("Books issued successfully!");
  //       handleCloseModals();
  //       localStorage.removeItem("studentId");
  //     } else {
  //       alert(`Error: ${data.message || "Failed to issue books"}`);
  //     }
  //   } catch (error) {
  //     console.error("Error issuing books:", error);
  //     alert("An error occurred while issuing books.");
  //   }
  // };


const handleIssueBook = async () => {
  const academicYearId = localStorage.getItem("academicSessionId");
  const createdBy = sessionStorage.getItem("userId");
  const issueDate = document.getElementById("issue-date")?.value || "";
  const studentId = localStorage.getItem("studentId");
  const teacherId = localStorage.getItem("teacherId") || employeeId;

  //  Collect only the actual accession numbers (barcode)
  const issuesBookDetails = rows
    .filter((row) => row.bookCode && row.barcode) // Only include rows with books selected
    .map((row) => row.barcode); // Only the number

  if (!academicYearId || !createdBy || !issueDate || issuesBookDetails.length === 0) {
    alert("Please fill all required fields before issuing books.");
    return;
  }

  const hasStudent = Boolean(studentId);
  const hasTeacher = Boolean(teacherId);

  if (!hasStudent && !hasTeacher) {
    alert("Please select either a student or a teacher before issuing books.");
    return;
  }

  if (hasStudent && hasTeacher) {
    alert("Please select only one recipient: student or teacher.");
    return;
  }

  const requestBody = {
    academic_year_id: Number(academicYearId),
    staffId: hasTeacher ? Number(teacherId) : null,
    studentId: hasStudent ? Number(studentId) : null,
    issueDate: issueDate,
    issuesBookDetails: issuesBookDetails, //  only array of accession numbers
    created_by: Number(createdBy),
  };

  try {
    const response = await fetch(
      `${ApiUrl.apiurl}ISSUEBOOK/BOOKISSUE_CREATE/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      }
    );

    const data = await response.json();
    if (data.message === "success") {
      alert("Books issued successfully!");
      handleCloseModals();
      localStorage.removeItem("studentId");
      localStorage.removeItem("teacherId");
    } else {
      const errorMessage =
        data.error || data.message || "Failed to issue books";

      if (errorMessage.toLowerCase().includes("limit")) {
        alert("Book issue limit reached for this student.");
      } else {
        alert(errorMessage);
      }
    }
  } catch (error) {
    console.error("Error issuing books:", error);
    alert("An error occurred while issuing books.");
  }
};



  const handleCloseModals = () => {
    navigate("/admin/book-movements");
  };
  const addNewRow = () => {
    setRows([
      ...rows,
      {
        id: rows.length + 1,
        bookCode: "",
        bookName: "",
        bookAccessionNo: "",
        category: "",
        subCategory: "",
      },
    ]);
  };
  const deleteRow = (id) => {
    setRows(rows.filter((row) => row.id !== id));
  };
  const handleInputChange = (id, event) => {
    const { name, value } = event.target;
    setRows(
      rows.map((row) => (row.id === id ? { ...row, [name]: value } : row))
    );
  };
  const dateRef = useRef(null);
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    if (dateRef.current) {
      dateRef.current.value = today; // Set default value to current date
      dateRef.current.max = today; // Restrict future dates
    }
  }, []);
  const handleClear = () => {
    setStudentName("");
    setEmployeeName("");
    setEmployeeId("");
    setClassId(null);
    setSectionId(null);
    setAddno("");
    setBarCode("");
    localStorage.removeItem("studentId");
    localStorage.removeItem("teacherId");
    // Clearing the input fields manually if needed
    if (dateRef.current) {
      dateRef.current.value = "";
    }
  };
  const handleOpenModal = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const openModal = () => setModalVisible(true);
  const closeModal = () => setModalVisible(false);
  // Book List Modal
  const [rows, setRows] = useState(
    Array.from({ length: 6 }, (_, index) => ({ id: index + 1 }))
  );
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [showBookModal, setShowBookModal] = useState(false);
  const handleBookSelection = (selectedBook) => {
    const {
      id,
      bookCode,
      bookName,
      barcode,
      categoryName,
      subcategoryName,
      availableCopies,
    } =
      selectedBook;
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === selectedRowId
          ? {
              ...row,
              bookCode: bookCode || "",
              bookName: bookName || "",
              barcode: barcode || "",
              categoryName: categoryName || "",
              subcategoryName: subcategoryName || "",
              availableCopies: availableCopies || "",
            }
          : row
      )
    );
    setShowBookModal(false); // Close modal after selection
  };
  const handleBarcodeChange = async (e, rowId) => {
    const enteredBarcode = e.target.value;

    // Update barcode field while typing
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === rowId ? { ...row, barcode: enteredBarcode } : row
      )
    );

    if (enteredBarcode.trim() === "") return; // Prevent API call if input is empty

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}LIBRARYBOOK/GetAllBooksDetails?barcodeNo=${enteredBarcode}`
      );
      const data = await response.json();

      if (data.message === "success" && data.data && data.data.length > 0) {
        const matchedBook = data.data[0]; // Assuming the response data contains a single book object

        if (matchedBook) {
          setRows((prevRows) =>
            prevRows.map((row) =>
              row.id === rowId
                ? {
                    ...row,
                    barcode: matchedBook.barcode || enteredBarcode,
                    bookCode: matchedBook.bookCode || "",
                    bookName: matchedBook.bookName || "",
                    categoryName: matchedBook.categoryName || "",
                    subcategoryName: matchedBook.subcategoryName || "",
                    availableCopies: matchedBook.availableCopies || "",
                  }
                : row
            )
          );
        }
      }
    } catch (error) {
      console.error("Error fetching book data:", error);
    }
  };
  const handleOpenBookModal = (rowId) => {
    setSelectedRowId(rowId);
    setShowBookModal(true);
  };
  const handleCloseBookModal = () => {
    setShowBookModal(false);
  };

  // select Student =========================================
  const [classId, setClassId] = useState(null);
  const [sectionId, setSectionId] = useState(null);
  const [studentName, setStudentName] = useState("");
  const [studentId, setStudentId] = useState("");
  const [classOptions, setClassOptions] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [addNo, setAddno] = useState("");
  const [barCode, setBarCode] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [employeeName, setEmployeeName] = useState("");

  const handleSelectStudent = (selectedStudent) => {
    const fullName = [
      selectedStudent.studentBasicDetails.first_name || "",
      selectedStudent.studentBasicDetails.middle_name || "",
      selectedStudent.studentBasicDetails.last_name || "",
    ]
      .filter(Boolean)
      .join(" ");

    // Set studentId when selecting a student (we will use this for the search)
    // setStudentId(selectedStudent.studentBasicDetails.id || "");
    const studentId = selectedStudent.studentBasicDetails.id || ""; // Get the student ID first
    setStudentId(studentId);
    localStorage.setItem("studentId", studentId); // Store in localStorage immediately
    localStorage.removeItem("teacherId");
    setEmployeeId("");
    setEmployeeName("");
    setStudentName(fullName);
    setClassId(selectedStudent.studentBasicDetails.addmitted_class || null);
    setSectionId(selectedStudent.studentBasicDetails.addmitted_section || null);
    setAddno(selectedStudent.studentBasicDetails.school_admission_no || null);
    setBarCode(selectedStudent.studentBasicDetails.school_admission_no || null);

    handleCloseModal();
  };
   const handleSelectEmployee = (selectedEmployee) => {
     console.log("Selected Employee:", selectedEmployee);

     const teacherId = selectedEmployee.id || "";
     setEmployeeId(teacherId);
     setEmployeeName(selectedEmployee.employeeName || "");
     localStorage.setItem("teacherId", teacherId);
     localStorage.removeItem("studentId");
     setStudentId("");
     setStudentName("");
     setClassId(null);
     setSectionId(null);
     setAddno("");
     setBarCode("");
   };
  useEffect(() => {
    const fetchClassData = async () => {
      try {
        const response = await fetch(`${ApiUrl.apiurl}Class/GetAllClass`);
        const data = await response.json();

        if (data.message === "Success") {
          const formattedClasses = data.data.map((classItem) => ({
            value: classItem.id,
            label: classItem.classname,
          }));
          setClassOptions(formattedClasses);
        } else {
          console.error("Failed to fetch classes: ", data.message);
        }
      } catch (error) {
        console.error("Error fetching class data:", error);
      }
    };

    fetchClassData();
  }, []);
  useEffect(() => {
    const fetchSectionData = async () => {
      if (!classId) {
        setSectionOptions([]); // Clear sections if no class selected
        return;
      }

      console.log("Fetching sections for classId:", classId); // Debugging

      try {
        const response = await fetch(
          `${ApiUrl.apiurl}ClassSectionBind/GetAllSectionBindWithClass/${classId}`
        );
        const data = await response.json();

        console.log("Section API response:", data); // Debugging

        if (data.message === "success") {
          const formattedSections = data.data.map((sectionItem) => ({
            value: sectionItem.section_id,
            label: sectionItem.sectionname,
          }));
          setSectionOptions(formattedSections);
        } else {
          console.error("Failed to fetch sections: ", data.message);
          setSectionOptions([]);
        }
      } catch (error) {
        console.error("Error fetching section data:", error);
        setSectionOptions([]);
      }
    };

    fetchSectionData();
  }, [classId]);

  return (
    <div className="container-fluid ">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                BOOK ISSUE
              </p>
              <div className="row mb-2 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleIssueBook}
                  >
                    Issue Book
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleCloseModals}
                  >
                    Close
                  </button>
                </div>
              </div>
              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 mb-3 ">
                      <div className="col-12 col-md-3 mb-3 ">
                        <label htmlFor="student-name" className="form-label">
                          Student Name
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            className="form-control detail"
                            placeholder="Enter student name"
                            value={studentName}
                            onChange={(e) => setStudentName(e.target.value)}
                          />
                          <button
                            type="button"
                            className="btn btn-primary ms-2 mb-0 mt-0"
                            onClick={handleOpenModal}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </button>
                        </div>
                      </div>
                      <SelectStudentModal
                        show={showModal}
                        handleClose={handleCloseModal}
                        onSelectStudent={handleSelectStudent}
                      />
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="teacher-name" className="form-label">
                          Teacher Name
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="teacher-name"
                            value={employeeName}
                            className="form-control detail"
                            placeholder="Enter teacher name"
                          />
                          <Button
                            type="button"
                            className="btn btn-primary ms-2 mb-0 mt-0"
                            onClick={openModal}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </Button>
                        </div>
                        <SelectStaffModal
                          isVisible={isModalVisible}
                          onClose={closeModal}
                          onSelectEmployee={handleSelectEmployee}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="admission-no" className="form-label">
                          Admission No
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="admission-no"
                            className="form-control detail"
                            value={addNo}
                            placeholder="Enter admission no"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="student-barcode" className="form-label">
                          Student Barcode
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="student-barcode"
                            className="form-control detail"
                            value={barCode}
                            placeholder="Enter student barcode"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="class" className="form-label">
                          Class
                        </label>
                        <Select
                          options={classOptions}
                          className="detail"
                          classNamePrefix="react-select"
                          placeholder="Select Class"
                          value={
                            classOptions.find(
                              (option) => option.value === classId
                            ) || null
                          } // Match the selected class
                          onChange={(selectedOption) =>
                            setClassId(
                              selectedOption ? selectedOption.value : null
                            )
                          }
                        />
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="section" className="form-label">
                          Section
                        </label>
                        <Select
                          options={sectionOptions}
                          className="detail"
                          classNamePrefix="react-select"
                          placeholder="Select Section"
                          value={
                            sectionOptions.find(
                              (option) => option.value === sectionId
                            ) || null
                          }
                          onChange={(selectedOption) => {
                            console.log(
                              "Selected sectionId:",
                              selectedOption ? selectedOption.value : null
                            ); // Debugging
                            setSectionId(
                              selectedOption ? selectedOption.value : null
                            );
                          }}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-2">
                        <label htmlFor="issue-date" className="form-label">
                          Issue Date
                        </label>
                        <input
                          type="date"
                          id="issue-date"
                          className="form-control detail"
                          ref={dateRef}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr No</th>
                        <th>Book Code</th>
                        <th>Book Name</th>
                        <th>Book Accession No</th>
                        <th>Available Copies</th>
                        <th>Category</th>
                        <th>Sub-Category</th>
                        <th>Delete</th>
                        <th>Return</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row, index) => (
                        <tr key={row.id}>
                          <td>{index + 1}</td>
                          <td>
                            <div className="d-flex align-items-center">
                              <Form.Control
                                type="text"
                                name="bookCode"
                                className="form-control detail me-2"
                                value={row.bookCode}
                                // onChange={(e) => updateBookCode(row.id, e)}
                                // className="me-2"
                              />
                              <button
                                type="button"
                                className="btn btn-primary mb-0 mt-0"
                                onClick={() => handleOpenBookModal(row.id)}
                                style={{ width: "50px", padding: "3px" }}
                              >
                                ...
                              </button>
                            </div>
                            <AdmBook
                              show={showBookModal}
                              handleClose={handleCloseBookModal}
                              selectedRowId={selectedRowId}
                              onSelectBook={handleBookSelection}
                            />
                          </td>

                          <td>
                            <Form.Control
                              type="text"
                              className="form-control detail"
                              name="bookName"
                              value={row.bookName}
                              onChange={(e) => handleInputChange(row.id, e)}
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="text"
                              className="form-control detail"
                              name="bookAccessionNo"
                              value={row.barcode}
                              onChange={(e) => handleBarcodeChange(e, row.id)}
                            />
                          </td>
                          <td>{row.availableCopies || ""}</td>
                          <td>
                            <Form.Control
                              type="text"
                              name="category"
                              className="form-control detail"
                              value={row.categoryName}
                              onChange={(e) => handleInputChange(row.id, e)}
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="text"
                              className="form-control detail"
                              name="subCategory"
                              value={row.subcategoryName}
                              onChange={(e) => handleInputChange(row.id, e)}
                            />
                          </td>
                          <td>
                            <Button
                              variant="link"
                              onClick={() => deleteRow(row.id)}
                            >
                              Delete
                            </Button>
                          </td>
                          <td>{}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-end">
                  <Button variant="primary" onClick={addNewRow}>
                    Add New Row
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
